module.exports = __webpack_public_path__ + "static/media/stoptb_logo.c3ec6f18.png";